var _defs, _path, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPreviewIcon(_ref, svgRef) {
  let title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "undo_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.657,
    height: 21.657,
    viewBox: "0 0 21.657 21.657",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2448",
    d: "M0-682.665H20.229v20.229H0Z",
    transform: "translate(0 682.665)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_61984",
    "data-name": "Path 61984",
    d: "M0,0H21.657V21.657H0Z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vision",
    transform: "translate(0.714 0.712)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2442",
    transform: "translate(0 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2444"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2446",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2452",
    transform: "translate(0.751 3.793)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2454",
    d: "M-610.683-207.011s-3,6.321-9.324,6.321-9.324-6.321-9.324-6.321,3-6.322,9.324-6.322S-610.683-207.011-610.683-207.011Z",
    transform: "translate(629.332 213.333)",
    fill: "rgba(0,0,0,0)",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2456",
    transform: "translate(6.914 6.954)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2458",
    d: "M-207.011-103.506a3.161,3.161,0,0,0-3.161-3.161,3.161,3.161,0,0,0-3.161,3.161,3.161,3.161,0,0,0,3.161,3.161A3.161,3.161,0,0,0-207.011-103.506Z",
    transform: "translate(213.333 106.666)",
    fill: "rgba(0,0,0,0)",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4
  }))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewIcon);
export default __webpack_public_path__ + "static/media/PreviewIcon.fff3499b2e6c554c8f679d4c8c3efd3e.svg";
export { ForwardRef as ReactComponent };